import React from 'react';
import PropTypes from 'prop-types';
import { OverlayView } from '@react-google-maps/api';
import ReactTooltip from 'react-tooltip';

const Marker = ({ lat, lng, title, description }) => {
  return (
    <OverlayView position={{ lat, lng }} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
      <div className="map_marker">
        <div className="oval" data-tip data-for="map" />
        {title && (
          <ReactTooltip id="map" effect="solid">
            {title && <p className="title">{title}</p>}
            {description && <p className="address">{description}</p>}
          </ReactTooltip>
        )}
      </div>
    </OverlayView>
  );
};

Marker.defaultProps = {
  title: '',
  description: '',
};

export default Marker;
